<template>
    <div class="mb-4 row" v-if="quotationData != null">

        <div class="col-lg-12 col-md-12">
            <transition name="fade">
                <div class="loading" v-show="loading">
                    <span class="fa fa-spinner fa-spin"></span> Loading
                </div>
            </transition>
            <div class="list-row" id="infinite-list">
                <div class="customcolumn column1 new-rfq">
                    <div class="list-box">
                        <div class="inr-title" role="group">
                            <div class="d-flex">
                                <div class="flex-grow-1">New RFQ</div>
                                <div class="flex-shrink-0">
                                    <small class="badge bg-success align-bottom ms-1" v-if="quotationData.quotations_data != null && quotationData.quotations_data.new">
                                        {{quotationData.quotations_data.new.total}}
                                    </small>
                                </div>
                            </div>

                        </div>
                        <div class="list-container" @scroll="itemListContainerScroll($event, 'new')" v-if="quotationData.quotations_data != null && quotationData.quotations_data.new && quotationData.quotations_data.new.data">
                            <draggable
                                :disabled="diableDrag"
                                :id="'draggable_0'"
                                class="list-group"
                                :list="quotationData.quotations_data.new.data"
                                draggable=".item"
                                group="a"
                                @change="handleChange($event, 1)"
                            >
                                <div class="quote-list item"
                                     v-for="(item, itemIndex) in quotationData.quotations_data.new.data"
                                     :id="item.id"
                                     :key="item.id" :class="{'mark-as-important': item.priority == 1}">
                                    <div class="white-bg quote-block">
                                        <div class="quote-header">
                                            <div class="quote-header-title">

                                                <div class="q-nmbr">
                                                    <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="quote_view">
                                                        #{{ item.quotation_number }}
                                                    </router-link>
                                                    <span v-if="item.id != item.parent_quote" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                </div>
                                            </div>
                                            <div class="quote-header-right">
                                                <!--<span v-if="item.id != item.parent_quote" class="lt-bl-bgs blue clone-btn">clone</span>
                                                <span v-if="quotationData.can_delete_quotation" class="pull-right lght-clr">
                                                    <a href="javascript:void(0);" v-on:click="removeItem(item.id)" class="del_btn" title="Delete Quote" :data-id="item.id"><i class="fa fa-trash-alt"></i></a>
                                                </span>-->
                                                <div class="btn-group">
                                                    <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                        <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                        <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                        <li><a class="dropdown-item"  href="javascript:void(0);" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div v-if="item.quote_name" class="item-name">{{item.quote_name}}</div>
                                            <div v-else class="item-name">{{item.item_name}}</div>
                                            <div class="customer-name" >
                                                <b>Customer :</b>
                                                <template v-if="item.customer_data">
                                                    {{item.customer_data.company_name}} <span class="contact-name" v-if="item.contact_name">, {{ucfirst(item.contact_name)}}</span>
                                                </template>

                                            </div>

                                            <div class="user-name"><b>Added By: </b> {{item.added_user_name}}</div>
                                        </div>


                                    </div>
                                    <div class="quote-footer">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('new', item.id, 'created')">Created: <span :title="getQuoteTimeByType('new', item.id, 'created')">
                                                {{formatDate(item.quote_date)}}
                                            </span></small>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('new', item.id, 'updated')">Updated: <span :title="getQuoteTimeByType('new', item.id, 'updated')">
                                                {{formatDate(item.updated_at)}}
                                            </span></small>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>

                <div class="customcolumn column2 sent-to-vendor">
                    <div class="list-box">
                        <div class="inr-title" role="group">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    Sent to Vendor
                                </div>
                                <div class="flex-shrink-0">
                                    <small class="badge bg-info align-bottom ms-1" v-if="quotationData.quotations_data != null && quotationData.quotations_data.sent_vendor">
                                        {{quotationData.quotations_data.sent_vendor.total}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="list-container" @scroll="itemListContainerScroll($event, 'sent_vendor')" v-if="quotationData.quotations_data != null && quotationData.quotations_data.sent_vendor && quotationData.quotations_data.sent_vendor.data">
                            <draggable
                                :disabled="diableDrag"
                                :id="'draggable_1'"
                                class="list-group"
                                :list="quotationData.quotations_data.sent_vendor.data"
                                draggable=".item"
                                group="a"
                                @change="handleChange($event, 2)"
                            >
                                <div class="quote-list item"
                                     v-for="(item, itemIndex) in quotationData.quotations_data.sent_vendor.data"
                                     :id="item.id"
                                     :key="item.id"
                                     :class="{'mark-as-important': item.priority == 1}">
                                    <div class="white-bg quote-block">
                                        <div class="quote-header">
                                            <div class="quote-header-title">

                                                <div class="q-nmbr">
                                                    <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="quote_view">
                                                        #{{ item.quotation_number }}
                                                    </router-link>
                                                    <span v-if="item.id != item.parent_quote" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                </div>
                                            </div>
                                            <div class="quote-header-right">
                                                <div class="btn-group">
                                                    <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                        <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                        <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                        <li><a class="dropdown-item"  href="javascript:void(0);" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div v-if="item.quote_name" class="item-name">{{item.quote_name}}</div>
                                            <div v-else class="item-name">{{item.item_name}}</div>
                                            <div class="customer-name" >
                                                <b>Customer :</b>
                                                <template v-if="item.customer_data">
                                                    {{item.customer_data.company_name}} <span class="contact-name" v-if="item.contact_name">, {{ucfirst(item.contact_name)}}</span>
                                                </template>
                                            </div>
                                            <div class="user-name"><b>Added By: </b> {{item.added_user_name}}</div>

                                        </div>


                                    </div>
                                    <div class="quote-footer">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('sent_vendor', item.id, 'created')">Created: <span :title="getQuoteTimeByType('sent_vendor', item.id, 'created')">
                                                {{formatDate(item.quote_date)}}
                                            </span></small>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('sent_vendor', item.id, 'updated')">Updated: <span :title="getQuoteTimeByType('sent_vendor', item.id, 'updated')">
                                                {{formatDate(item.updated_at)}}
                                            </span></small>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>

                <div class="customcolumn column3 price-confirmation">
                    <div class="list-box">
                        <div class="inr-title" role="group">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    Price Confirmation
                                </div>
                                <div class="flex-shrink-0">
                                    <small class="badge bg-primary align-bottom ms-1" v-if="quotationData.quotations_data != null && quotationData.quotations_data.save_price">
                                        {{quotationData.quotations_data.save_price.total}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="list-container" @scroll="itemListContainerScroll($event, 'save_price')" v-if="quotationData.quotations_data != null && quotationData.quotations_data.save_price && quotationData.quotations_data.save_price.data">
                            <draggable
                                :disabled="diableDrag"
                                :id="'draggable_2'"
                                class="list-group"
                                :list="quotationData.quotations_data.save_price.data"
                                draggable=".item"
                                group="a"
                                @change="handleChange($event, 3)"
                            >
                                <div class="quote-list item"
                                     v-for="(item, itemIndex) in quotationData.quotations_data.save_price.data"
                                     :id="item.id"
                                     :key="item.id" :class="{'mark-as-important': item.priority == 1}">
                                    <div class="white-bg quote-block">
                                        <div class="quote-header">
                                            <div class="quote-header-title">

                                                <div class="q-nmbr">
                                                    <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="quote_view">
                                                        #{{ item.quotation_number }}
                                                    </router-link>
                                                    <span v-if="item.id != item.parent_quote" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                </div>
                                                <div class="item-name"></div>
                                            </div>
                                            <div class="quote-header-right">
                                                <div class="btn-group">
                                                    <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                        <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                        <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                        <li><a class="dropdown-item"  href="javascript:void(0);" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div v-if="item.quote_name" class="item-name">{{item.quote_name}}</div>
                                            <div v-else class="item-name">{{item.item_name}}</div>
                                            <div class="customer-name">
                                                <b>Customer :</b>
                                                <template v-if="item.customer_data">
                                                    {{item.customer_data.company_name}} <span class="contact-name" v-if="item.contact_name">, {{ucfirst(item.contact_name)}}</span>
                                                </template>
                                            </div>
                                            <div class="user-name"><b>Added By: </b> {{item.added_user_name}}</div>

                                        </div>


                                    </div>

                                    <div class="quote-footer">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('save_price', item.id, 'created')">Created: <span  :title="getQuoteTimeByType('save_price', item.id, 'created')">
                                                {{formatDate(item.quote_date)}}
                                            </span></small>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('save_price', item.id, 'updated')">Updated: <span  :title="getQuoteTimeByType('save_price', item.id, 'updated')">
                                                {{formatDate(item.updated_at)}}
                                            </span></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>

                <div class="customcolumn column4 price-approved">
                    <div class="list-box">
                        <div class="inr-title" role="group">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    Price Approved
                                </div>
                                <div class="flex-shrink-0">
                                    <small class="badge bg-danger align-bottom ms-1" v-if="quotationData.quotations_data != null && quotationData.quotations_data.price_approve">
                                        {{quotationData.quotations_data.price_approve.total}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="list-container" @scroll="itemListContainerScroll($event, 'price_approve')" v-if="quotationData.quotations_data != null && quotationData.quotations_data.price_approve && quotationData.quotations_data.price_approve.data">
                            <draggable
                                :disabled="diableDrag"
                                :id="'draggable_3'"
                                class="list-group"
                                :list="quotationData.quotations_data.price_approve.data"
                                draggable=".item"
                                group="a"
                                @change="handleChange($event, 5)"
                            >
                                <div class="quote-list item"
                                     v-for="(item, itemIndex) in quotationData.quotations_data.price_approve.data"
                                     :id="item.id"
                                     :key="item.id" :class="{'mark-as-important': item.priority == 1}">
                                    <div class="white-bg quote-block">
                                        <div class="quote-header">
                                            <div class="quote-header-title">

                                                <div class="q-nmbr">
                                                    <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="quote_view">
                                                        #{{ item.quotation_number }}
                                                    </router-link>
                                                    <span v-if="item.id != item.parent_quote" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                </div>
                                                <div class="item-name"></div>
                                            </div>
                                            <div class="quote-header-right">
                                                <div class="btn-group">
                                                    <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                        <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                        <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                        <li><a class="dropdown-item"  href="javascript:void(0);" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div v-if="item.quote_name" class="item-name">{{item.quote_name}}</div>
                                            <div v-else class="item-name">{{item.item_name}}</div>
                                            <div class="customer-name">
                                                <b>Customer :</b>
                                                <template v-if="item.customer_data">
                                                    {{item.customer_data.company_name}} <span class="contact-name" v-if="item.contact_name">, {{ucfirst(item.contact_name)}}</span>
                                                </template>
                                            </div>
                                            <div class="user-name"><b>Added By: </b> {{item.added_user_name}}</div>

                                        </div>


                                    </div>

                                    <div class="quote-footer">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('price_approve', item.id, 'created')">Created: <span  :title="getQuoteTimeByType('price_approve', item.id, 'created')">
                                                {{formatDate(item.quote_date)}}
                                            </span></small>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('price_approve', item.id, 'updated')">Updated: <span  :title="getQuoteTimeByType('price_approve', item.id, 'updated')">
                                                {{formatDate(item.updated_at)}}
                                            </span></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>

                <div class="customcolumn column5 sent-to-customer">
                    <div class="list-box">
                        <div class="inr-title" role="group">
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    Sent to Customer
                                </div>
                                <div class="flex-shrink-0">
                                    <small class="badge bg-warning align-bottom ms-1" v-if="quotationData.quotations_data != null && quotationData.quotations_data.sent_customer">
                                        {{quotationData.quotations_data.sent_customer.total}}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="list-container" @scroll="itemListContainerScroll($event, 'sent_customer')" v-if="quotationData.quotations_data != null && quotationData.quotations_data.sent_customer && quotationData.quotations_data.sent_customer.data">
                            <draggable
                                :disabled="diableDrag"
                                :id="'draggable_4'"
                                class="list-group"
                                :list="quotationData.quotations_data.sent_customer.data"
                                draggable=".item"
                                group="a"
                                @change="handleChange($event, 4)"
                            >
                                <div class="quote-list item"
                                     v-for="(item, itemIndex) in quotationData.quotations_data.sent_customer.data"
                                     :id="item.id"
                                     :key="item.id" :class="{'mark-as-important': item.priority == 1}">
                                    <div class="white-bg quote-block">
                                        <div class="quote-header">
                                            <div class="quote-header-title">

                                                <div class="q-nmbr">
                                                    <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="quote_view">
                                                        #{{ item.quotation_number }}
                                                    </router-link>
                                                    <span v-if="item.id != item.parent_quote" class="badge badge-soft-danger align-bottom ms-1">Clone</span>
                                                </div>
                                                <div class="item-name"></div>
                                            </div>
                                            <div class="quote-header-right">
                                                <div class="btn-group">
                                                    <a href="javascript:void(0);" class="text-muted dropdown-toggle" :id="'dropdownMenuLink1_'+item.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="ri-more-fill"></i></a>
                                                    <ul class="dropdown-menu" :aria-labelledby="'dropdownMenuLink1_'+item.id">
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> View</a></li>
                                                        <li><a class="dropdown-item" href="javascript:void(0);" @click="goToView(item.id)"><i class="ri-edit-2-line align-bottom me-2 text-muted"></i> Edit</a></li>
                                                        <li v-if="item.priority != 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 1)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Mark Important</a></li>
                                                        <li v-if="item.priority == 1"><a class="dropdown-item" href="javascript:void(0);" @click="changePriority(item.id, 0)"><i class="ri-checkbox-circle-fill align-bottom me-2 text-muted"></i> Un-mark Important</a></li>
                                                        <li><a class="dropdown-item"  href="javascript:void(0);" @click="removeItem(item.id)"><i class="ri-delete-bin-5-line align-bottom me-2 text-muted"></i> Delete</a></li>
                                                    </ul>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="content-section">
                                            <div v-if="item.quote_name" class="item-name">{{item.quote_name}}</div>
                                            <div v-else class="item-name">{{item.item_name}}</div>
                                            <div class="customer-name" >
                                                <b>Customer :</b>
                                                <template v-if="item.customer_data">
                                                    {{item.customer_data.company_name}} <span class="contact-name" v-if="item.contact_name">, {{ucfirst(item.contact_name)}}</span>
                                                </template>
                                            </div>
                                            <div class="user-name"><b>Added By: </b> {{item.added_user_name}}</div>

                                        </div>


                                    </div>

                                    <div class="quote-footer">
                                        <div class="d-flex">
                                            <div class="flex-grow-1">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('sent_customer', item.id, 'created')">Created: <span  :title="getQuoteTimeByType('sent_customer', item.id, 'created')">
                                                {{formatDate(item.quote_date)}}
                                            </span></small>
                                            </div>
                                            <div class="flex-shrink-0">
                                                <small class="text-muted mb-0 fw-bold" :title="getQuoteTimeByType('sent_customer', item.id, 'updated')">Updated: <span  :title="getQuoteTimeByType('sent_customer', item.id, 'updated')">
                                                {{formatDate(item.updated_at)}}
                                            </span></small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import draggable from 'vuedraggable';
import Vue from "vue";
import { isMobile } from 'mobile-device-detect';

export default {
    name: "QuotationGrid",
    components: {draggable},
    props: ['bus', 'quotationData', 'loadedScrollAllPage'],
    created() {

    },
    beforeMount() {
        this.scrollPage = 1;
    },
    
    mounted() {

        /*const listElm = document.querySelector('#infinite-list');

        listElm.addEventListener('scroll', e => {
            console.log(e);
            if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                this.scrollPage += 1;
                console.log(this.scrollPage);
            }
        });*/

        /*window.onscroll = () => {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
            if (bottomOfWindow && this.loadedScrollAllPage == 0) {
                this.scrollPage += 1;
            }
        }*/
    },
    data() {
        return {
            diableDrag: isMobile ? true : false,
            msg: isMobile ? 'Welcome to Your Vue.js mobile App!' : 'Welcome to Your Vue.js App',
            dragging: false,
            scrollPage: 1
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading'
        ]),
        itemListContainerScroll(event, item) {
            const { scrollTop, offsetHeight, scrollHeight } = event.target
            if ((scrollTop + offsetHeight) >= scrollHeight) {
                console.log('bottom!')
                this.$emit('changeScrollGridItem', {item: item});
            }
            //console.log(item)
            //console.log(event)
        },
        goToView(id) {
            this.$router.push({name: 'viewQuote', params: {id: id}});
        },
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete quote?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        changePriority(id, priority){
            this.$emit('changePriority', {id: id, priority: priority});
        },
        handleChange(event, statusId) {
            if(event.added) {
                //console.log('changed', event.added.element.id);
                //console.log('changed-st', status.id);

                let changeData = {
                    quote_id: event.added.element.id,
                    status: statusId
                }
                this.$emit('changeStatusEvent', changeData);
            }
        },

        getQuoteTimeByType(type, id, time){
            if(this.quotationData.quote_time &&
                this.quotationData.quote_time[type] &&
                this.quotationData.quote_time[type][id] &&
                this.quotationData.quote_time[type][id][time]){
                return this.quotationData.quote_time[type][id][time];
            }
            return '';
        },

    },
    watch: {
        scrollPage: {
            handler: function (value) {
                if (value != 1) {
                    this.$emit('changeScrollPage', this.scrollPage);
                }
            }
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading'
        ])
    }
}
</script>

<style scoped>

</style>
